export const RouteName = {
  LOGIN: 'Login',
  H5_LOGIN: 'H5Login',
  ERROR: 'Error',
  NOT_OPEN: 'NotOpen',
  HOME: 'Home',
  MSG_AUDIT_INDEX: 'MsgAuditIndex',
  SETTINGS_INDEX: 'SettingsIndex',
  MSG_AUDIT_SETTINGS: 'MsgAuditSettings',
  MSG_AUDIT_RECORD: 'MsgAuditRecord',
  MSG_AUDIT_SETTINGS_EDIT: 'MsgAuditSettingsEdit',
  MSG_AUDIT_CONTACT: 'MsgAuditContact',
  EXTERNAL_CONTACT_SETTINGS: 'ExternalContactSettings',
  EXTERNAL_CONTACT_SETTINGS_EDIT: 'ExternalContactSettingsEdit',
  /**
   * 会话内容
   */
  GLOBAL_SEARCH: 'GlobalSearch',
  CHAT_RECORD: 'ChatRecord',
  CHAT_RECORD_CUSTOMER: 'ChatRecordCustomer',
  CHAT_RECORD_GROUP: 'ChatRecordGroup',
  CHAT_RECORD_REVOKE: 'ChatRecordRevoke',
  CHAT_RECORD_GROUP_REVOKE: 'ChatRecordGroupRevoke',
  CHAT_RECORD_VOICE_CALL: 'ChatRecordVoiceCall',
  SETTING_VOICE: 'SettingVoice',
  /**
   * 审计操作
   */
  AUDIT_RECORD: 'AuditRecord',
  AUDIT_TYPE: 'AuditType',
  /**
   * 客户管理
   */
  CUSTOMER_LIST: 'CustomerList',
  CUSTOMER_WELCOME: 'CustomerWelcome',
  /**
   * 数据统计
   */
  STATISTICS: 'Statistics',
  /**
   * 敏感词设置
   */
  SENSITIVITY_MANAGE: 'SensitivityManage',
  SENSITIVITY_RECORD: 'SensitivityRecord',
  SENSITIVITY_NOTICE: 'SensitivityNotice',
  /**
   * 回复超时设置
   */
  REPLY_TIMEOUT: 'ReplyTimeout',
  REPLY_TIMEOUT_LOG: 'ReplyTimeoutLog',
  /**
   * 敏感行为设置
   */
  RULE_SAVE: 'RuleSave',
  RULE_LIST: 'RuleList',
  /**
   * 导出中心
   */
  EXPORT: 'Export',
  /**
   * 系统设置
   */
  SETTING_DEPARTMENT_USER: 'SettingDepartmentUser',
  SETTING_ROLE: 'SettingRole',
  SETTING_DATA: 'SettingData',
  SETTING_PARAMETER: 'SettingParameter',
  SETTING_CUSTOMER: 'SettingCustomer',
  SETTING_SPACE: 'SettingSpace',
  SETTING_LOG: 'SettingLog',
  SETTING_SAFETY: 'SettingSafety',
  /**
   * 单聊统计
   * 联系客户统计
   * 成员联系明细
   */
  USER_BEHAVIOR_DATA: 'UserBehaviorData',
  USER_CONTACT_DATA: 'UserContactData',

  /**
   * 离职继承管理
   */
  INHERIT_ADMIN: 'InheritAdmin',
  INHERIT_LIST: 'InheritList',
  INHERIT_CONTACTS: 'InheritContacts',
  INHERIT_SIDE: 'InheritSide',
  INHERIT_GROUP_SIDE: 'InheritGroupSide',

  /**
   * 特殊功能
   */
  SPECIAL_FUNCTION_MAIL: 'SpecialFunctionMail',
  AI_MAIL: 'Mail',
  AI_MAIL_SUMMARY: 'MailSummary',
};
